export const handleBodyUnlock = () => {
  if ('bodyScrollFix' in document.body.dataset && Object.hasOwn(document.body.dataset, 'bodyScrollFix')) {
    const scrollPosition = document.body.dataset.bodyScrollFix;
    delete document.body.dataset.bodyScrollFix;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.width = '';
    window.scroll(0, scrollPosition);
  }
};
